import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, CircularProgress, Typography } from '@mui/material';

const CustomerDropdown = ({  customers = [], selectedCustomerId, onChange }) => {
  const [options, setOptions] = useState(customers || []);
  const [loading, setLoading] = useState(false);

  // Find selected customer object by ID
  const selectedCustomer = options.find(c => c.customerid === selectedCustomerId) || null;

  useEffect(() => {
    setOptions(customers);
  }, [customers]);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={(option) => option.customername || ''}
      loading={loading}
      value={selectedCustomer}
      isOptionEqualToValue={(option, value) => option.customerid === value.customerid}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue.customerid);
        } else {
          onChange('');
        }
      }}
      renderOption={(props, option) => (
        <li {...props} key={option.customerid} style={{ display: 'block' }}>
          <Typography component="div" variant="body2" fontWeight="normal">
            {option.customername}
          </Typography>
          <Typography component="div" variant="caption" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
            {option.customerprimarycontactname}, {option.customerprimarycontactemailaddress}, {option.customerprimarycontactphone}
          </Typography>
        </li>
      )}
      renderInput={(params) => (
        <TextField 
          {...params} 
          label="Customer" 
          size="small" 
          placeholder="Select Customer" 
          InputProps={{ 
            ...params.InputProps, 
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
          sx={{ minWidth: 200 }}
        />
      )}
    />
  );
};

export default CustomerDropdown;
